const vi = {
  label: '🇻🇳 Vietnamese',
  ipa: {
    97: {
      ex: (
        <span>
          <b>ă</b>n, m<b>a</b>y, c<b>a</b>u
        </span>
      ),
    },
    99: {
      ex: (
        <span>
          <b>ch</b>è
        </span>
      ),
    },
    101: {
      ex: (
        <span>
          v<b>ề</b>, c<b>â</b>y
        </span>
      ),
    },
    102: {
      ex: (
        <span>
          <b>ph</b>ở
        </span>
      ),
    },
    104: {
      ex: (
        <span>
          <b>h</b>àng
        </span>
      ),
    },
    105: {
      ex: (
        <span>
          kh<b>i</b>, đ<b>i</b>
        </span>
      ),
    },
    106: {
      ex: (
        <span>
          <b>d</b>a, <b>d</b>anh, <b>gi</b>à (southern dialect)
        </span>
      ),
    },
    107: {
      ex: (
        <span>
          <b>c</b>ô, <b>k</b>em
        </span>
      ),
    },
    108: {
      ex: (
        <span>
          <b>l</b>à
        </span>
      ),
    },
    109: {
      ex: (
        <span>
          <b>m</b>ai
        </span>
      ),
    },
    110: {
      ex: (
        <span>
          <b>n</b>am
        </span>
      ),
    },
    111: {
      ex: (
        <span>
          c<b>ô</b>
        </span>
      ),
    },
    112: {
      ex: (
        <span>
          <b>p</b>in
        </span>
      ),
    },
    114: {
      ex: (
        <span>
          <b>r</b>a, <b>r</b>ồi
        </span>
      ),
    },
    115: {
      ex: (
        <span>
          <b>x</b>a, <b>s</b>áu (southern dialect)
        </span>
      ),
    },
    116: {
      ex: (
        <span>
          <b>t</b>ây
        </span>
      ),
    },
    117: {
      ex: (
        <span>
          r<b>u</b>, t<b>u</b>
        </span>
      ),
    },
    118: {
      ex: (
        <span>
          <b>v</b>ề
        </span>
      ),
    },
    119: {
      ex: (
        <span>
          <b>qu</b>anh
        </span>
      ),
    },
    120: {
      ex: (
        <span>
          <b>kh</b>ô (northern dialect)
        </span>
      ),
    },
    122: {
      ex: (
        <span>
          <b>gi</b>à, <b>gi</b>ặt
        </span>
      ),
    },
    331: {
      ex: (
        <span>
          <b>ng</b>âm; <b>ngh</b>e
        </span>
      ),
    },
    595: {
      ex: (
        <span>
          <b>b</b>a
        </span>
      ),
    },
    599: {
      ex: (
        <span>
          <b>đ</b>i
        </span>
      ),
    },
    601: {
      ex: (
        <span>
          <b>â</b>n
        </span>
      ),
    },
    611: {
      ex: (
        <span>
          <b>g</b>a; <b>gh</b>ế
        </span>
      ),
    },
    616: {
      ex: (
        <span>
          t<b>ư</b>
        </span>
      ),
    },
    626: {
      ex: (
        <span>
          <b>nh</b>à
        </span>
      ),
    },
    642: {
      ex: (
        <span>
          <b>s</b>áu
        </span>
      ),
    },
    648: {
      ex: (
        <span>
          <b>tr</b>à
        </span>
      ),
    },
    660: { ex: <span>anh</span> },
    0x7403610255: {
      // TODO: check display character
      ex: (
        <span>
          <b>ch</b>è (northern dialect)
        </span>
      ),
    },
    0x6102d0: {
      ex: (
        <span>
          b<b>a</b>, m<b>a</b>i, c<b>a</b>o
        </span>
      ),
    },
    0x6b02b7: {
      ex: (
        <span>
          <b>qu</b>anh (northern dialect)
        </span>
      ),
    },
    0x6b02b0: {
      ex: (
        <span>
          <b>kh</b>ô (southern dialect)
        </span>
      ),
    },
    0x7402b0: {
      ex: (
        <span>
          <b>th</b>ầy
        </span>
      ),
    },
    0x025b02d0: {
      ex: (
        <span>
          x<b>e</b>
        </span>
      ),
    },
    0x025902d0: {
      ex: (
        <span>
          b<b>ơ</b>
        </span>
      ),
    },
    0x025402d0: {
      ex: (
        <span>
          x<b>oo</b>ng
        </span>
      ),
    },
    0x690259: {
      ex: (
        <span>
          v<b>iê</b>n, b<b>ia</b>
        </span>
      ),
    },
    0x02680259: {
      ex: (
        <span>
          x<b>ươ</b>ng, ch<b>ưa</b>
        </span>
      ),
    },
    0x750259: {
      ex: (
        <span>
          <b>uố</b>ng, m<b>ua</b>
        </span>
      ),
    },
    0x028803610282: {
      ex: (
        <span>
          <b>tr</b>à (northern dialect)
        </span>
      ),
    },
  },
};
export default vi;
